import { render } from "./EditorTextarea.vue?vue&type=template&id=571334d4"
import script from "./EditorTextarea.vue?vue&type=script&lang=js"
export * from "./EditorTextarea.vue?vue&type=script&lang=js"

import "./EditorTextarea.vue?vue&type=style&index=0&id=571334d4&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__